export interface CostCenterFilterType {
  selectedCostCenters: server.dto.CostCenter[]
}

export const getSortedCostCenters = (filter: CostCenterFilterType) => {
  return filter.selectedCostCenters.map(b => b.internalId)
    .sort((a, b) => a.localeCompare(b));
};

export const initialCostCenterFilter: CostCenterFilterType = {
  selectedCostCenters: []
};